
import validateProperty from './validate_property.js';

export default function validatePaintProperty(options) {
    return validateProperty(options, 'paint');
}
